import React from "react";

import EmbedScorecard from "./embed";
import PrimaryScorecard from "./primary";
import SecondaryScorecard from "./secondary";

import type { Sport } from "@/schemas";
import type { SportGameDetails } from "@/schemas/sport-game";

type ScorecardVariant = "primary" | "secondary" | "embed";

type ScorecardProps =
  | {
      variant: "primary";
      event: Sport | SportGameDetails | undefined;
      className?: string;
      /** Render team avatars as links to the team detail page. */
      linkTeams?: boolean;
    }
  | {
      variant: "secondary";
      event: Sport;
    }
  | {
      variant: "embed";
      event: SportGameDetails;
    };

const Scorecard = (props: ScorecardProps) => {
  if (props.variant === "primary") {
    if (!props.event) return null;
    return (
      <PrimaryScorecard
        event={props.event}
        className={props.className}
        linkTeams={props.linkTeams}
      />
    );
  }
  if (props.variant === "secondary") {
    return <SecondaryScorecard event={props.event} />;
  }
  return <EmbedScorecard event={props.event} />;
};

export { Scorecard, type ScorecardVariant };
export default Scorecard;
